import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="container-editorial py-32 text-center" data-testid="page-404">
      <p className="text-xs uppercase tracking-widest text-viola/60">404</p>
      <h1 className="mt-4 font-display text-6xl tracking-tighter">Pagina non trovata.</h1>
      <p className="mt-4 text-viola/75">La pagina che stai cercando non esiste (o non esiste ancora).</p>
      <Link to="/" className="mt-8 btn-primary inline-flex">Torna alla home</Link>
    </div>
  );
}
